
<template>
    <div>
        <div class="box title-box is-shadowless is-radiusless" v-if="references.length || currentAccountIsSameAs(student) || isEmployee">
            <h2 class="title is-5 is-inline-tablet">Referencer</h2>
            <small class="has-text-grey is-inline">Se nogle eksempler på opgaver jeg tidligere har udført</small>
        </div>

        <div class='columns is-multiline'>
            <reference v-for="reference in references" :reference="reference" :key="reference.id" :student="student" />

            <div class='column is-4-desktop is-6-tablet is-12-mobile' v-if="references.length < 6 && (currentAccountIsSameAs(student) || isEmployee)">
                <create-reference :student-id="student.id" />
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .title-box {
        margin-bottom: 0.75rem !important;
        padding: .75rem 1.25rem !important;

        h2 {
            margin-bottom: 0.75rem !important;
            margin-right: 0.75rem !important;
        }
    }
</style>

<script>
    import AccountMixin from '@/global/mixins/AccountMixin';
    import CreateReference from '@/taskflex/students/components/profile/references/CreateReference';
    import { mapGetters } from 'vuex';
    import Reference from '@/taskflex/students/components/profile/references/Reference';

    export default {
        props: {
            references: {
                type: Array,
                required: true,
            },

            student: {
                type: Object,
                required: true,
            },
        },

        mixins: [AccountMixin],

        computed: {
            ...mapGetters('auth', [
                'isCustomer',
                'isEmployee',
            ]),
        },

        components: {
            Reference,
            CreateReference,
        },
    };
</script>



// WEBPACK FOOTER //
// src/taskflex/students/components/profile/references/References.vue